import React, { useEffect, useRef } from 'react';
import './NavMenus.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { setLanguage } from '../i18n';

function NavLanguage({ onClose, buttonRef }) {
    const menuRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();


    const getNewPath = (lang) => {
        const pathParts = location.pathname.split("/").filter(Boolean);
        const supportedLanguages = ["en", "ro", "es", "de"];
    
        if (supportedLanguages.includes(pathParts[0])) {
            pathParts.shift(); // remove current language segment
        }
    
        const cleanPath = pathParts.join("/"); // "" when at root
    
        let newPath = "";
        if (lang === "en") {
            newPath = cleanPath ? `/${cleanPath}/` : "/"; // no trailing slash at root
        } else {
            newPath = cleanPath ? `/${lang}/${cleanPath}/` : `/${lang}/`; // avoid "/es/"
        }

        return newPath;
    }

    const handleLanguageChange = async (lang) => {
        await setLanguage(lang);
    
       
        onClose();
    };
    

    return (
        <div className='nav-menu-popup' ref={menuRef} style={{ width: "120px", left: -10 }}>
            <div className='d-flex justify-content-center' style={{ marginTop: -10 }}>
                <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.67777 2.24264C12.0209 -0.100505 15.8199 -0.100505 18.1631 2.24264L25.5981 9.67767C29.3779 13.4575 26.7009 19.9203 21.3554 19.9203H13.9204L6.48538 19.9203C1.13996 19.9203 -1.53705 13.4575 2.24274 9.67767L9.67777 2.24264Z" fill="#fff" />
                </svg>
            </div>
            <div className='nav-content'>
                <div className='nav-grid-1col'>
                    <div className='nav-grid-element d-flex align-items-start'>
                        <div className='d-flex flex-column align-items-start'>
                            <a href={getNewPath('en')} onClick={() => handleLanguageChange('en')}>English</a>
                        </div>
                    </div>
                    {/* <div className='nav-grid-element d-flex align-items-start'>
                        <div className='d-flex flex-column align-items-start'>
                            <label onClick={() => handleLanguageChange('ro')}>Romana</label>
                        </div>
                    </div> */}
                    <div className='nav-grid-element d-flex align-items-start'>
                        <div className='d-flex flex-column align-items-start'>
                            <a href={getNewPath('es')} onClick={() => handleLanguageChange('es')}>Espanol</a>
                        </div>
                    </div>
                    {/* <div className='nav-grid-element d-flex align-items-start'>
                        <div className='d-flex flex-column align-items-start'>
                            <label onClick={() => handleLanguageChange('de')}>Deutsch</label>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
}

export default NavLanguage;
